export default "__VITE_ASSET__BfwIMwqE__"